var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerBlue = function SvgMarkerBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "marker",
    viewBox: "0 0 20 48"
  }, props), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 27,
    fill: "#c4c4c4",
    opacity: 0.3,
    rx: 9,
    ry: 5,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    fillRule: "evenodd",
    d: "M10 32c5 0 9-2.2 9-5s-4-5-9-5-9 2.2-9 5 4 5 9 5",
    "data-name": "shadow",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4264fb",
    stroke: "#314ccd",
    strokeWidth: 0.5,
    d: "M19.25 10.4a13.1 13.1 0 0 1-1.46 5.224 41.5 41.5 0 0 1-3.247 5.548 71 71 0 0 1-4.542 5.945l-.217-.258a73.206 73.206 0 0 1-4.327-5.725 42 42 0 0 1-3.246-5.553A13 13 0 0 1 .75 10.4 9.466 9.466 0 0 1 10 .75a9.466 9.466 0 0 1 9.25 9.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#314ccd",
    strokeWidth: 0.5,
    d: "M13.55 10A3.55 3.55 0 1 1 10 6.45 3.55 3.55 0 0 1 13.55 10Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h20v48H0z"
  })));
};
export { SvgMarkerBlue as ReactComponent };
export default "data:image/svg+xml,%3c!-- Create a custom map style: https://studio.mapbox.com --%3e %3csvg id='marker' data-name='marker' xmlns='http://www.w3.org/2000/svg' width='20' height='48' viewBox='0 0 20 48'%3e %3cg id='mapbox-marker-icon'%3e %3cg id='icon'%3e %3cellipse id='shadow' cx='10' cy='27' rx='9' ry='5' fill='%23c4c4c4' opacity='0.3' style='isolation: isolate'/%3e %3cg id='mask' opacity='0.3'%3e %3cg id='group'%3e %3cpath id='shadow-2' data-name='shadow' fill='%23bfbfbf' d='M10%2c32c5%2c0%2c9-2.2%2c9-5s-4-5-9-5-9%2c2.2-9%2c5S5%2c32%2c10%2c32Z' fill-rule='evenodd'/%3e %3c/g%3e %3c/g%3e %3cpath id='color' fill='%234264fb' stroke='%23314ccd' stroke-width='0.5' d='M19.25%2c10.4a13.0663%2c13.0663%2c0%2c0%2c1-1.4607%2c5.2235%2c41.5281%2c41.5281%2c0%2c0%2c1-3.2459%2c5.5483c-1.1829%2c1.7369-2.3662%2c3.2784-3.2541%2c4.3859-.4438.5536-.8135.9984-1.0721%2c1.3046-.0844.1-.157.1852-.2164.2545-.06-.07-.1325-.1564-.2173-.2578-.2587-.3088-.6284-.7571-1.0723-1.3147-.8879-1.1154-2.0714-2.6664-3.2543-4.41a42.2677%2c42.2677%2c0%2c0%2c1-3.2463-5.5535A12.978%2c12.978%2c0%2c0%2c1%2c.75%2c10.4%2c9.4659%2c9.4659%2c0%2c0%2c1%2c10%2c.75%2c9.4659%2c9.4659%2c0%2c0%2c1%2c19.25%2c10.4Z'/%3e %3cpath id='circle' fill='white' stroke='%23314ccd' stroke-width='0.5' d='M13.55%2c10A3.55%2c3.55%2c0%2c1%2c1%2c10%2c6.45%2c3.5484%2c3.5484%2c0%2c0%2c1%2c13.55%2c10Z'/%3e %3c/g%3e %3c/g%3e %3crect width='20' height='48' fill='none'/%3e %3c/svg%3e";